import React from 'react'

class ModalRechazarRecibo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            comentario: null,
            isBotonDeshabilitado: true,
        };
        this.dialogRef = React.createRef();
    }

    componentDidMount() {
        // Manejar el estado inicial del modal
        if (this.props.isOpen) {
            this.abrirModal();
        }
    }

    componentDidUpdate(prevProps) {
        // Detectar cambios en isOpen para abrir/cerrar el modal
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.abrirModal();
            } else {
                this.cerrarModalConAnimacion();
            }
        }
    }

    abrirModal = () => {
        if (this.dialogRef.current && !this.dialogRef.current.open) {
            this.dialogRef.current.showModal();
        }
    }

    cerrarModal = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.close();
        }
    }

    cerrarModalConAnimacion = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.style.scale = '0';
            setTimeout(() => {
                if (this.dialogRef.current && this.dialogRef.current.open) {
                    this.dialogRef.current.close();
                }
            }, 300);
        }
    }

    manejarCancelar = () => {
        this.cerrarModalConAnimacion();
        setTimeout(() => {
            this.props.cerrarModal();
        }, 300);
    }

    manejarConfirmar = () => {
        this.props.onConfirmar?.(this.state.comentario);
    }

    handleInput = (e) => {
        let name = e.target.name;
        let val = e.target.value;
        this.setState({
            [name]: val,
            isBotonDeshabilitado: val.trim().length == 0 
        })
    };


    render() {
        const {
            claseBotonAccion = 'btn-medium btn-danger',
            isOpen
        } = this.props;

        const { isBotonDeshabilitado } = this.state;

        // No renderizar si no debe estar abierto
        if (!isOpen) return null;

        return (
            <div className="component-modal">
                <dialog
                    className="modal"
                    id="modal-delete-details"
                    ref={this.dialogRef}
                    onClose={this.manejarCancelar}
                >
                    <div className="modal-content">
                        <div className="modal-body">
                            <h3 className="title">
                                ¿Desea rechazar el documento?
                            </h3>
                            <p className="msg">
                                El documento será marcado como rechazado. Debe brindar un motivo para terminar esta acción
                            </p>

                            <div className="card">
                                <div className="card-info">
                                    <div className="form-group">
                                        <input type="text" id="comentario" name="comentario" className="form-input" placeholder=""
                                            onChange={this.handleInput} value={this.comentario} />
                                        <label htmlFor="comentario" className="form-label"> Motivo del rechazo </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn-medium btn-base-outline"
                                id="close-modal"
                                type="button"
                                onClick={this.manejarCancelar}
                            >
                                Cancelar
                            </button>

                            <button
                                className={`${claseBotonAccion} ${isBotonDeshabilitado ? 'btn-disabled-danger' : ''}`}
                                onClick={this.manejarConfirmar}
                                disabled={isBotonDeshabilitado}
                            >
                                Rechazar documento
                            </button>
                        </div>
                    </div>
                </dialog>
            </div>
        );
    }
}

export default ModalRechazarRecibo;